import { apiFetch } from "#lib/api";
import { IFavoritePost } from "#entities/account";

export async function fetchFavoritePosts() {
  const path = `/account/favorites`;
  const params = new URLSearchParams([["type", "post"]]);

  const data = await apiFetch<IFavoritePost[]>(
    path,
    { method: "GET" },
    params
  );

  return data;
}
